import React, { useState } from 'react';
import Lightbox from 'react-image-lightbox'; // Use a lightbox library
import 'react-image-lightbox/style.css'; // Import CSS for the lightbox

const PortfolioSection = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  
  const images = [
    "/images/ourfleets/1.jpg",
    "/images/ourfleets/2.jpg",
    "/images/ourfleets/3.jpg",
    "/images/ourfleets/4.jpg",
    "/images/ourfleets/5.jpg",
    "/images/ourfleets/6.jpg",
    "/images/ourfleets/7.jpg",
    "/images/ourfleets/8.avif",
    "/images/ourfleets/9.jpg",
    "/images/ourfleets/10.jpg",
    "/images/ourfleets/11.webp",
  
  ];

  const vehicleNames = [
     "SWIFT DESIRE",
      "Aura",
    "Toyota Rumion",
    "Innova Crysta",
    "Ertiga",
    "Kia Carens",
    "Innova",
    "Fortuner",
    "Tempo Traveller",
    "Urbania",
    "Mini Bus",
    "Luxury Bus",
  ];

  const openLightbox = (index) => {
    setCurrentImageIndex(index);
    setIsOpen(true);
  };

  const closeLightbox = () => {
    setIsOpen(false);
  };

  const nextImage = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const prevImage = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
  };

  return (
    <div>
    <section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1>Gallery</h1>
        </div>
      </div>
    </section>

    

      <div className="section-full site-bg-white p-t150 p-b120 twm-portfolio-wrap wow fadeInDown" data-wow-offset="100" data-wow-delay="0.2">
        <div className="container">
          <ul className="masonry-outer mfp-gallery work-grid row clearfix list-unstyled m-b0">
            {images.map((image, index) => (
            












<li key={index} className={`masonry-item cat-${(index % 4) + 1} col-lg-4 col-md-6 m-b30`}>
  <div className="gallery-card">
    <a className="gallery-link" href="#" onClick={() => openLightbox(index)}>
      <div className="gallery-img">
        <img src={image} alt={vehicleNames[index]} />
        <div className="gallery-overlay">
          <span className="icon-view"><i className="feather feather-maximize"></i></span>
        </div>
      </div>
    </a>
    <div className="gallery-info">
      <h3 className="gallery-title">{vehicleNames[index]}</h3>
    </div>

    {/* Logo Watermark */}
    <div className="gallery-logo">
      <img src="/images/logo.jpg" alt="Alpha Cabs Logo" />
    </div>
  </div>
</li>



            ))}
          </ul>

          {/* Lightbox Modal */}
          {isOpen && (
            <Lightbox
              mainSrc={images[currentImageIndex]}
              nextSrc={images[(currentImageIndex + 1) % images.length]}
              prevSrc={images[(currentImageIndex - 1 + images.length) % images.length]}
              onCloseRequest={closeLightbox}
              onMovePrevRequest={prevImage}
              onMoveNextRequest={nextImage}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default PortfolioSection;
